export default __webpack_public_path__ + "static/media/sms1.312ce72c.svg";